import { createContext } from 'react';

export type FormGroupContextType = {
  initialize: (propName: string) => void;
};

export const FormGroupContext = createContext<FormGroupContextType | null>(
  null
);
